// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilo para negrita en la primera columna */
.bold-cell {
  font-weight: 700;
}

/* Estilo para fila hover */
.custom-row:hover {
  background-color: #cce4ff !important; /* Celeste claro */
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tables/DataTable.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;EACE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC,EAAE,kBAAkB;EACxD,eAAe;AACjB","sourcesContent":["/* Estilo para negrita en la primera columna */\r\n.bold-cell {\r\n  font-weight: 700;\r\n}\r\n\r\n/* Estilo para fila hover */\r\n.custom-row:hover {\r\n  background-color: #cce4ff !important; /* Celeste claro */\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
